import { useTranslate } from '@/i18n';
import { Typography } from '@mui/material';
import { Link } from 'ui-kit';
import { inheritDataTestId } from 'ui-kit/lib/utils/dataTestId';
import React from 'react';
import { useMinutesCountDown } from '@/hooks/useMinutesCountdown.ts';

export const ResendPinCode = ({
  timeMs,
  reSend,
  ...props
}: {
  timeMs?: number | null;
  reSend?: () => void;
}) => {
  const { t } = useTranslate('common');
  const time = useMinutesCountDown(timeMs);
  return time ? (
    <Typography variant={'string/md'}>
      {t('THE_CODE_CAN_BE_RESENT_AFTER')}&nbsp;{time}
    </Typography>
  ) : (
    <Link
      onClick={reSend}
      color={'secondary'}
      sx={{ typography: 'link/md' }}
      data-test-id={inheritDataTestId(props, 're-send-link')}
    >
      {t('RESEND_PIN_CODE')}
    </Link>
  );
};
